import React, { FC } from 'react';
import classnames from 'classnames';
import { CircularProgress, Typography } from '@material-ui/core/';
import { Variant } from '@material-ui/core/styles/createTypography';
import Button from '../Button';
import styles from './LabelButton.styles';

interface LabelButtonProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  type?: 'button' | 'submit' | 'reset';
  containerClass?: string;
  disableRipple?: boolean;
  removeButton?: boolean;
  label: React.ReactNode;
  icon?: React.ReactNode;
  labelColor?: string;
  className?: string;
  disabled?: boolean;
  isLoading?: boolean;
  variant?: Variant;
}

const LabelButton: FC<LabelButtonProps> = ({
  labelColor = 'initial',
  disableRipple = false,
  removeButton = false,
  disabled = false,
  variant = 'body2',
  type = 'button',
  containerClass,
  isLoading,
  className,
  children,
  onClick,
  label,
  icon,
  ...props
}) => {
  const classes = styles();

  const buttonClass = classnames(classes.button, {
    [classes.remove]: removeButton,
  });

  const buttonIcon = () => {
    if (isLoading) {
      return <CircularProgress className={classes.spinner} data-testid="spinner" size="1rem" />;
    }
    return icon;
  };

  return (
    <div className={`${containerClass} ${classes.buttonContainer}`}>
      <Button
        className={`${className} ${buttonClass}`}
        disabled={isLoading || disabled}
        disableRipple={disableRipple}
        data-testid="label-button"
        labelColor={labelColor}
        isLoading={isLoading}
        icon={buttonIcon()}
        onClick={onClick}
        type={type}
        {...props}
      >
        <Typography variant={variant} className={classes.content}>
          {label}
        </Typography>
      </Button>
    </div>
  );
};

export default LabelButton;
